import Form from 'client/core/Form';

export default class CheckoutPlaceOrderForm extends Form {
    async onSubmit() {
        let isValid = await this.validate();

        return { submitted: isValid, form: this.$el };
    }
}
